import ExtensionCapability from '../../capability';
import { Specs, attachHandler } from '@doxyme/extensions-common';

type Constraints = Specs.FileTransfer.Constraints;

const { FileTransfer } = Specs;

export type StartHandler = () => void;

/**
 * File Transfer allows extensions to use the file transfer service within the host application.
 */
export default class FileTransferCapability extends ExtensionCapability<Constraints> {
  static readonly id = FileTransfer.id;

  protected readonly startHandlers: StartHandler[] = [];

  constructor() {
    super(FileTransfer);

    this.handlers.push([FileTransfer.Actions.Start, this.start.bind(this)]);
  }

  private start(): void {
    for (const handler of this.startHandlers) {
      handler();
    }
  }

  onStart(handler: StartHandler): () => void {
    return attachHandler<StartHandler>(this.startHandlers, handler);
  }
}
